import type { MessageRouter } from "#public"
import type { ReceiverInput } from "#public"
import type { ReceiverOutput } from "#public"

export const RoundRobin = <T, R>(routers: MessageRouter<T, R>[]): MessageRouter<T, R> => {
  if (routers.length === 0) {
    throw new Error("RoundRobin requires at least one router")
  } else if (routers.length === 1) {
    return routers[0]
  }

  let i = 0

  return (request: ReceiverInput<T>): ReceiverOutput<R> => {
    // Get the current router
    const router = routers[i]

    // Rotate to the next router for the next invocation
    i = (i + 1) % routers.length

    // Invoke the current router
    return router(request)
  }
}
